module.exports = __webpack_public_path__ + "img/dsci0050.8a957b34.jpg";